/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresListFiles } from "../../funcs/llmVectorStoresListFiles.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListVectorStoreFilesRequest$inboundSchema,
};

export const tool$llmVectorStoresListFiles: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-list-files",
  description: `List files in a vector store

Retrieves a paginated list of all files in a specific vector store.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresListFiles(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
